import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./contexts/AuthContext";
import { Toast } from "./components";
import App from "./App";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "./styles.scss";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
        <Toast />
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>
);
